import {
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
  Stack,
  Switch,
  SwitchProps,
  Tooltip,
} from "@mui/material";
import { modificateRequiredRule } from "helpers/validation/utils";
import React from "react";
import { useController, UseControllerProps } from "react-hook-form";

export type SwitchControlProps = {
  name: string;
  label?: string | React.ReactNode;
  tooltipTitle?: string;
  rules?: UseControllerProps["rules"];
  formControlLabelProps?: Partial<FormControlLabelProps>;
  hint?: string;
};

const SwitchControl = ({
  name,
  label,
  tooltipTitle,
  disabled,
  rules,
  formControlLabelProps,
  hint,
}: SwitchProps & SwitchControlProps) => {
  const {
    field: { value, onChange },
  } = useController({ name, defaultValue: false, rules: modificateRequiredRule(rules) });

  return (
    <Stack>
      <FormControlLabel
        control={
          <Switch
            checked={value}
            onChange={(_, checked) => onChange(checked)}
            disabled={disabled}
          />
        }
        label={
          label && (
            <Tooltip title={tooltipTitle}>
              <span>{label}</span>
            </Tooltip>
          )
        }
        {...formControlLabelProps}
      />
      {hint && <FormHelperText>{hint}</FormHelperText>}
    </Stack>
  );
};

export default SwitchControl;
